import { render } from "./ChartDiagram.vue?vue&type=template&id=006dd06b&scoped=true"
import script from "./ChartDiagram.vue?vue&type=script&lang=js"
export * from "./ChartDiagram.vue?vue&type=script&lang=js"

import "./ChartDiagram.vue?vue&type=style&index=0&id=006dd06b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006dd06b"]])

export default __exports__